import React from 'react';
import { connect } from 'react-redux';

import { Form } from "components/common";
import MainFieldSet from './MainFieldSet';


const HiddenDomainForm = (props) => {
  const { showEditForm } = props.hiddenDomain;

  const onClose = () => {
    props.actions.hiddenDomain.showEditForm({ show: false });
  };

  const onSubmit = data => {
    props.actions.hiddenDomain.update(data);
  };

  return (
    <Form
      title="Редактирование скрытого домена"
      name="hiddenDomainForm"
      model={props.hiddenDomain}
      visible={showEditForm}
      onClose={onClose}
      onSubmit={onSubmit}
      convertEditObject={(editObject) => ({...editObject})}
    >
      <MainFieldSet {...props}/>
    </Form>
  )
};

const mapState = state => ({
  hiddenDomain: state.hiddenDomain,
});

const mapDispatch = dispatch => ({
  actions: {
    hiddenDomain: dispatch.hiddenDomain,
  }
});

export default connect(mapState, mapDispatch)(HiddenDomainForm);
